// extracted by mini-css-extract-plugin
export default {"emptyStateInfo":"EmptyStateInfo_emptyStateInfo__2WcEz","text":"EmptyStateInfo_text__C5QGs"};